import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import LayoutPage from '../Layout';
import swal from "sweetalert2";


function ArticleDetail() {
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState("");
    const [heading, setHeading] = useState("");
    const [descriptionData, setDescriptionData] = useState("");
    const [newContent, setNewContent] = useState({});
    const [pdf, setPdf] = useState();
    const { id } = useParams();
    const navigate = useNavigate();
    const [initialValue, setInitialValues] = useState({
      heading: "",
      description: "",
      pdfFile: null,
    });

    const validationSchema = Yup.object({
      heading: Yup.string()
        .max(500, "Heading must be at most 500 characters")
        .trim()
        .required("Heading is a required field"),
      description: Yup.string()
        .max(2000, "Description must be at most 2,000 characters")
        .trim()
        .required("Description is a required field"),
      pdfFile: Yup.mixed()
        // .required("PDF is required")
        .nullable()
        .test("fileFormat", "Only PDF files are allowed", (value) => {
          if (value) {
            const isFile = value instanceof File;

            const isFileExtension =
              typeof value === "string" && /\.(pdf)$/i.test(value);
            return isFile || isFileExtension;
          }
          return true;
        }),
    });

    const formik = useFormik({
      initialValues: initialValue,
      validationSchema,
      enableReinitialize: true,
      onSubmit: async (values) => {
        // console.log("valllllllll", values);
        //    setDisabledSubmit(true);
        try {
          let formData = new FormData();
          formData.append("pdfFile", values.pdfFile);
          formData.append("heading", values.heading);
          formData.append("description", values.description);
          // console.log("Formdata", formData);
          let res = await axios.patch(
            `admin-website/updateArticle/${id}`,
            formData
          );
          // console.log("res ==> ", res);
          // setRenderPage(Math.random());
          // setDisabledSubmit(false);
          toast(res.data.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: "success",
          });

          navigate("/research-articles");

          // navigate("/category", { state: { message: res.data.message } });
        } catch (errors) {
          if (errors.response.data.error) {
            toast(errors.response.data.error.message, {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              type: "error",
            });
          }
          // setDisabledSubmit(false);
        }
      },
    });

    // const handleNewsImage = (e) => {
    //   const file = e.target.files[0];
    //   setImage(file);
    //   formik.setFieldValue("newsImage", file);
    // };

    useEffect(() => {
      setLoading(true);
      axios
        .get(`/admin-website/get-article/${id}`)
        .then((res) => res.data.data)
        .then((data) => {
          // console.log(data);
          setInitialValues({
            heading: data.heading,
            description: data.description,
            pdfFile: data.pdfFile,
          });
          setPdf(data.pdfFile);
          setHeading(data.heading);
          setTitle(data.topic);
          setDescriptionData(data.description);
          setLoading(false);
        });
    }, []);

    const newContentData = {
      pageContent: newContent,
    };

    const updateContent = (e) => {
      setLoading(true);
      // console.log("id", newContentData);
      // console.log("new content ==> ", newContentData);
      axios
        .patch(`/content/${id}`, newContentData)
        .then((res) => {
          // console.log(res);
          // console.log(newContentData.pageContent.split(":"));
          // setLoading(false);
          swal.fire({
            text: "Updated Successfully!",
            icon: "info",
            timer: 2000,
            timerProgressBar: true,
            showConfirmButton: false,
          });
          navigate(-1);
        })
        .catch((err) => {
          // setLoading(false);
          // console.log("res ==> ", err.response.data.message);
          let msg = err.response.data.message;
          swal.fire({
            text: `${msg}`,
            icon: "info",
            timer: 2000,
            timerProgressBar: true,
            showConfirmButton: false,
          });
        });
    };

    const handleCloseButton = () => {
      navigate(-1);
    };

  return (
    <>
      <LayoutPage>
        <div className="row">
          <div className="col-12">
            <div className="card my-4">
              <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                <div
                  style={{
                    backgroundColor: "#46456e",
                  }}
                  className=" shadow-primary border-radius-lg pt-4 pb-3"
                >
                  <div className="d-flex ps-3 align-item-center">
                    <i
                      style={{ color: "#fff", cursor: "pointer" }}
                      className="fa fa-arrow-left fs-4"
                      onClick={() => {
                        navigate(-1);
                      }}
                    ></i>
                    <h6 className="text-white text-capitalize ps-4 ">
                      RESEARCH ARTICLES
                    </h6>
                  </div>
                </div>
              </div>
              <div className="card-body px-0 pb-2">
                <div className="p-4">
                  <form onSubmit={formik.handleSubmit}>
                    <div className="input-group input-group-outline mb-3">
                      <label className="fs-5">Topic: </label>
                      <label className="fs-5 mx-2">{title}</label>
                    </div>

                    <div className="input-group input-group-outline mb-3">
                      <label className="fs-5">Heading</label>

                      <input
                        style={{ width: "100%" }}
                        type="text"
                        id="heading"
                        name="heading"
                        className="form-control fs-6"
                        autoComplete="off"
                        placeholder="Heading"
                        value={formik.values.heading || ""}
                        onChange={formik.handleChange}
                      />
                    </div>
                    {formik.errors.heading ? (
                      <div className="text-danger">{formik.errors.heading}</div>
                    ) : null}

                    <div className="input-group input-group-outline mb-3">
                      <label className="fs-5">Description</label>
                      <input
                        style={{ width: "100%" }}
                        type="text"
                        id="description"
                        name="description"
                        className="form-control fs-6"
                        autoComplete="off"
                        placeholder="Description "
                        value={formik.values.description || ""}
                        onChange={formik.handleChange}
                      />
                    </div>
                    {formik.errors.description ? (
                      <div className="text-danger">
                        {formik.errors.description}
                      </div>
                    ) : null}

                    <div className="image-container input-group input-group-outline mb-3">
                      <input
                        style={{
                          width: "100%",
                          padding: "10px",
                          fontSize: "16px",
                          borderRadius: "5px",
                          outline: "none",
                          border: "1px solid #ccc",
                          height: "50px",
                        }}
                        type="file"
                        id="pdfFile"
                        name="pdfFile"
                        // className="form-control"
                        placeholder="Pdf file"
                        onChange={(event) => {
                          formik.setFieldValue(
                            "pdfFile",
                            // setformImage(event.target.files[0]),
                            event.target.files[0]
                          );
                        }}
                        // onChange={handleNewsImage}
                      />
                    </div>
                    {formik.errors.pdfFile ? (
                      <div className="text-danger">{formik.errors.pdfFile}</div>
                    ) : null}

                    <button
                      type="submit"
                      className="Submit my-3 btn-lg w-20 mt-4 mb-0 "
                      style={{
                        // width: "200px",
                        borderRadius: "5px",
                        height: "50px",
                        marginLeft: "450px",
                        backgroundColor: "#46456e",
                        color: "#fff",
                      }}
                    >
                      Submit
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutPage>
    </>
  );
}

export default ArticleDetail
